// Date is #E97627 — the Tableau-orange entry of the shared MI charting palette (STANDARDS.md
// "Chart color palette"), not an off-palette amber. Model/Dataset/Domain colors stay
// DB-driven per node (root nodes render individually, never through a shared legend entry),
// so this map only needs the satellite types that share one legend/color per model.
export const SATELLITE_TYPE_COLORS: Record<'Measure' | 'Dimension' | 'Date', string> = {
    Measure: '#075B7E',
    Dimension: '#4EA7FC',
    Date: '#E97627',
};

// Outline for a node the selected report uses. Deliberately the app's text color rather than a
// new accent — the highlight is structural, and color stays reserved for meaningful status.
export const REPORT_ACTIVE_STROKE = '#222222';
export const REPORT_ACTIVE_STROKE_WIDTH = 2.5;

export function satelliteColor(type: string, fallback: string | null): string {
    return (SATELLITE_TYPE_COLORS as Record<string, string>)[type] ?? fallback ?? '#6b7280';
}
